import {
  collection,
  query,
  getDocs,
  getDocsFromServer,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../types";
import { Conversation } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type ConversationListService<T> = (
  sessionId: string,
  opts?: ListServiceOpts
) => Promise<Array<T>>;

const list: ConversationListService<EntityGet<Conversation>> = async (
  sessionId,
  opts = {}
) => {
  const collectionRef = collection(db, `/session/${sessionId}/conversation`);
  const { disableCache } = opts;
  const q =
    typeof opts.listQueryFn === "function"
      ? opts.listQueryFn(collectionRef)
      : query(collectionRef);
  const getFn = disableCache ? getDocsFromServer : getDocs;
  const querySnapshot = await getFn(q);
  return querySnapshot.docs.map((doc) => {
    return processTimestampFields(
      transformMetadata({
        ...doc.data(),
        id: doc.id,
      } as EntityServerGet<Conversation>)
    ) as EntityGet<Conversation>;
  });
};

export default list;
